import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {MedicalRecordProblemModel} from '../../../api/model/medicalRecordProblem.model';

@Injectable({providedIn: 'root'})
export class MedicalProblemRepository extends AbstractRepositoryV2<MedicalRecordProblemModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalProblem', serviceElementsFactory, injector);
    }
}
